import { useEffect, useCallback } from "react";
import { useAuthenticatedApi } from "./useAuthenticatedApi";
import { useFeatureStore } from "../store/featureStore";

export const useFeatures = () => {
  const api = useAuthenticatedApi();

  const tier = useFeatureStore((s) => s.tier);
  const features = useFeatureStore((s) => s.features);
  const loading = useFeatureStore((s) => s.loading);
  const error = useFeatureStore((s) => s.error);
  const has = useFeatureStore((s) => s.has);
  const load = useFeatureStore((s) => s.load);

  useEffect(() => {
    if (api) {
      load(api);
    }
  }, [api, load]);

  const refresh = useCallback(() => {
    if (api) return load(api);
    return Promise.resolve();
  }, [api, load]);

  return { tier, features, has, loading, error, refresh };
};
